module.exports = __webpack_public_path__ + "img/JD Seraphine.e0fdc4a0.jpg";